interface WidgetsGridProps {
  type?: 'default' | 'single-column';
  children: React.ReactNode;
}

export function WidgetsGrid({ type = 'default', children }: WidgetsGridProps) {
  if (type === 'single-column') {
    return <div className="grid grid-cols-1 gap-8">{children}</div>;
  }
  return <div className="grid sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">{children}</div>;
}
